import React from "react";

import usePageMeta from "../utils/usePageMeta";
import { SITE_NAME, CONTACT_EMAIL, POLICY_UPDATED } from "../utils/site";

export default function Disclaimer() {
  usePageMeta({
    title: "Disclaimer",
    description: `${SITE_NAME} is informational only. What the analytics mean, what they cannot tell you, and where to get help.`,
    path: "/disclaimer",
  });

  return (
    <div className="page prose">
      <h1>Disclaimer</h1>
      <p className="policy-date">Last updated {POLICY_UPDATED}</p>

      <h2>No predictions</h2>
      <p>
        {SITE_NAME} provides lottery results and statistics for information and
        entertainment. <strong>Nothing here predicts a draw.</strong> Lottery
        draws are independent random events: the digits that came up last week
        have no bearing on the digits that come up tonight, and no analysis of
        past results can change that.
      </p>
      <p>
        Our charts show how often each digit has appeared against how often a
        fair draw would produce it. Where the two differ, that difference is
        ordinary sampling variation — what randomness looks like at a small
        sample size — and not a pattern to bet on. Any site or service claiming
        it can tell you which numbers are due is wrong, and usually selling
        something.
      </p>

      <h2>Number generators</h2>
      <p>
        Generated picks on this site are random and are offered for fun. They are
        not derived from the analytics, are not more likely to win than numbers
        you choose yourself, and carry no advantage of any kind.
      </p>

      <h2>Not the official source</h2>
      <p>
        {SITE_NAME} is an independent site. It is not affiliated with, endorsed
        by, or connected to the California State Lottery. Results shown here come
        from the Lottery's published feed and may be delayed or incorrect. Always
        check a ticket against the California Lottery's official published
        results — never against this site.
      </p>

      <h2>Not financial advice</h2>
      <p>
        Nothing on this site is financial advice. Playing the lottery has a
        negative expected return: over time, players collectively receive back
        less than they spend. Treat any money spent as the cost of entertainment
        you can afford to lose, not as an investment or a plan.
      </p>

      <h2>Community content</h2>
      <p>
        Posts and comments are written by visitors and express their views, not
        ours. We do not verify claims made in them, and strategies described
        there work no better than any other choice of numbers.
      </p>

      <h2>Play responsibly</h2>
      <p>
        You must be 18 or older to play. If gambling stops being fun — if you are
        spending more than you meant to, chasing losses, or hiding it — free,
        confidential help is available 24 hours a day on{" "}
        <strong>1-800-GAMBLER</strong> (1-800-426-2537).
      </p>

      <h2>Contact</h2>
      <p>
        Corrections and questions:{" "}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </div>
  );
}
